module.exports = __webpack_public_path__ + "img/db.01596d3c.png";